import styled from "styled-components";
import { Header } from "components/styled";
const gray = "#f7f3f2";

export const LeaderboardTop = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 64px 0;
  border-top: 1px solid #9ba885;
  border-bottom: 1px solid #9ba885;
  text-align: center;
  justify-content: center;
  align-items: center;
  &::before,
  &::after {
    content: " ";
    position: absolute;
    height: 8px;
    background-size: auto 8px;
    width: 88px;
  }
  &::before {
    top: 16px;
    right: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='88' height='8' viewBox='0 0 88 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='4' height='8' fill='%239BA885'/%3E%3Crect x='12' width='4' height='8' fill='%239BA885'/%3E%3Crect x='24' width='64' height='8' fill='%239BA885'/%3E%3C/svg%3E%0A");
  }
  &::after {
    left: 0;
    bottom: 16px;
    background-image: url("data:image/svg+xml,%3Csvg width='72' height='8' viewBox='0 0 72 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='4' height='8' fill='%239BA885'/%3E%3Crect x='12' width='4' height='8' fill='%239BA885'/%3E%3Crect x='24' width='4' height='8' fill='%239BA885'/%3E%3Crect x='36' width='24' height='8' fill='%239BA885'/%3E%3Crect x='68' width='4' height='8' fill='%239BA885'/%3E%3C/svg%3E%0A");
    width: 72px;
  }
`;
export const PlacePic = styled.img`
  display: block;
  width: 152px;
  height: 152px;
  object-fit: contain;
`;

export const PlacePicContainer = styled.div`
  display: block;
  width: fit-content;
  margin: 0 auto;
  position: relative;
`;

export const PlaceAbsolutePic = styled.img`
  position: absolute;
  width: 48px;
  height: 48px;
  object-fit: contain;
  top: -16px;
  right: -16px;
`;

export const EmailButton = styled.button`
  border-radius: 16px;
  height: 64px;
  font-weight: 400;
  font-variation-settings: "wght" 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
  border: 0;
  outline: 0;
  white-space: nowrap;
  cursor: pointer;
  transition: 300ms ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fcfc03;
  color: var(--text-primary-on-brand, #000);
  margin: 0 auto;
  padding: 0 38px;
  &.white {
    background: var(--fill-primary);
  }

  p.action {
    color: var(--text-primary-on-brand, #000);
  }
  &:hover {
    // background: #3a3836;
  }
  &:active {
    transform: scale(0.95);
  }

  &.button-brand {
    background: #99ffee;
    color: #000;
    &:hover {
      background: #69f2e0;
    }
  }
`;

export const PnL = styled.div`
  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-positive-bg, rgba(71, 89, 62, 0.72));
  backdrop-filter: blur(12px);
  padding: var(--spacing-space-4, 4px) var(--spacing-space-12, 12px);
  width: fit-content;
  margin: 0 auto;
  p.body {
    color: var(--text-positive, #45be33);
    font-variation-settings: "wght" 600;
  }
  &.negative {
    background: var(--fill-negative-bg);
    p.body {
      color: var(--text-negative);
    }
  }
`;

export const RatingItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 0;
  &.pointer {
    cursor: pointer;
  }
  & + & {
    margin-top: 12px;
  }
  &.small-gaps {
    & + & {
      margin-top: 8px;
    }
  }
  @media (max-width: 1024px) {
    padding: 8px 0;
  }
  @media (max-width: 528px) {
    gap: 8px;
  }
`;

export const RatingNum = styled.div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #72706e;
  font-variation-settings: "wght" 600;
  overflow: hidden;
  width: max-content;
  overflow: hidden;
  flex-shrink: 0;
  min-width: 22px;
  &.referral {
    position: relative;
    background: rgba(204, 187, 184, 0.16);
    border-radius: 50%;
    display: flex;
    align-items: center;
    font-variation-settings: "wght" 600;
    color: var(--text-primary);
    width: 28px;
    height: 28px;
    justify-content: center;
  }
`;

export const RatingTeamInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 104px;
  width: 104px;
  span {
    margin-bottom: 0;
  }

  @media (max-width: 1024px) {
    max-width: 86px;
    width: 86px;
    span {
      max-width: 74px;
    }

    &.wide {
      max-width: 100%;
      span {
        max-width: 100%;
      }
    }
  }
  @media (max-width: 380px) {
    max-width: 100px;
  }

  &.full-width {
    width: 100%;
    max-width: 100%;
    span {
      max-width: 100%;
    }
  }
  &.sm {
    width: 80px;
    max-width: 80px;
  }
`;

export const YourRank = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: rgba(66, 61, 60, 0.64);
`;

export const Icon = styled.div`
  background: ${gray};
  background-blend-mode: multiply;
  border-radius: 50%;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;
  flex-shrink: 0;
  img {
    width: 16px;
    height: 16px;
  }
  &.lg {
    width: 48px;
    height: 48px;
    margin-right: 8px;
    img {
      width: 24px;
      height: 24px;
    }
  }

  .captain {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
`;

export const ParticipantsCount = styled(RatingNum)`
  &.referral {
    width: fit-content;
    border-radius: var(--rounding-radius-m, 16px);
    backdrop-filter: blur(12px);
    font-weight: 400;
    font-variation-settings: "wght" 500;
    padding: var(--spacing-space-4, 4px) var(--spacing-space-8, 8px);
    height: 24px;
  }
`;

export const RatingTotals = styled.div<{ pnl?: number }>`
  background: ${({ pnl }) => {
    if (!pnl) return "#CCBBB829";
    if (pnl > 0) return "var(--fill-positive-bg, rgba(71, 89, 62, 0.72))";
    if (pnl < 0) return "var(--fill-negative-bg)";
  }};
  color: ${({ pnl }) => {
    if (!pnl) return "#000000";
    if (pnl > 0) return "#45BE33";
    if (pnl < 0) return "#E54796";
  }};
  border-radius: 16px;
  height: 24px;
  padding: 4px 8px;
  font-style: italic;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  margin-left: auto;
  white-space: nowrap;
`;

export const ShowMoreButton = styled.button`
  border: 0;
  outline: 0;
  padding: 8px 12px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0.03em;
  font-variation-settings: "wght" 700;
  cursor: pointer;
  transition: 300ms ease-out;
  width: 100%;
  height: 48px;
  border-radius: var(--rounding-radius-xs, 8px);
  background: var(--fill-elevated, rgba(204, 187, 184, 0.16));
  box-shadow: 0px 4px 8px 0px rgba(51, 20, 0, 0.08),
    0px 2px 1px 0px rgba(51, 20, 0, 0.04);
  color: var(--text-primary, #faf8f7);

  &:hover {
    background: var(--fill-elevated-hover, rgba(178, 162, 162, 0.32));
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const RatingEpicItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 32px;
  margin: 0 auto 0 20px;
  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
    object-position: center;
  }

  @media (max-width: 1024px) {
    min-height: 32px;
    span {
      display: none;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
  @media (max-width: 768px) {
    span {
      display: block;
    }
  }
  @media (max-width: 528px) {
    margin: 0 auto 0 10px;
    span {
      display: none;
    }
    &.in-modal {
      margin: 0 auto 0 30px;
    }
  }
`;

export const ReferrealBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto 0 50px;
  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
    object-position: center;
  }
  @media (max-width: 528px) {
    margin: 0 auto 0 10px;
  }
`;

export const TextCenter = styled.div`
  text-align: center;
  * {
    text-align: center;
  }
`;

export const BadgesBoxOverflow = styled.div`
  max-width: 100%;
  padding: 0 24px;

  overflow: scroll;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::-webkit-scrollbar {
    width: 0px;
    opacity: 0;
    background-color: transparent;
    display: none;
  }
  &::-webkit-scrollbar:horizontal {
    opacity: 0;
    height: 0px;
    display: none;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    opacity: 0;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }
  @media (max-width: 1024px) {
    margin: 0 -24px;
    max-width: calc(100% + 48px);
    display: flex;
    padding: 0 36px;

    &::after {
      content: " ";
      display: block;
      width: 24px;
    }
  }
`;

export const BadgesBox = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .main-picture {
    width: 136px;
    height: 136px;
    object-fit: contain;
    object-position: center;
  }
  .label {
    border-radius: var(--rounding-radius-m, 16px);
    background: var(--fill-accent-secondary, rgba(50, 250, 220, 0.16));
    backdrop-filter: blur(12px);
  }
`;

export const SignInRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 100%;
  gap: 18px;
  & > a {
    width: fit-content;
  }

  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    margin-top: auto;
    gap: 30px;
  }
`;

export const ReferBock = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .pic {
    width: 198px;
    height: 134px;
    object-fit: contain;
    margin: 0 auto;
  }
  ${Header} {
    white-space: nowrap;
  }
  .full-width {
    width: 100%;
  }
  .copylink {
    width: 100%;
    max-width: calc(100vw - 48px);
  }

  @media (min-width: 1024px) {
    max-width: 1056px;
    margin: 0 auto;
    display: grid;
    gap: 0 48px;
    grid-template-columns: 476px 1fr;
    .title {
      text-align: left;
    }
  }
  @media (max-width: 1024px) {
    max-width: 100%;
    ${Header} {
      white-space: nowrap;
    }
  }
`;

export const RankingBlock = styled.div`
  padding: 48px 24px 24px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
  border-radius: var(--rounding-radius-xxl, 32px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));

  @media (max-width: 1024px) {
    padding-top: 32px;
    margin: 24px -24px 0;
    width: calc(100% + 48px);
  }
`;

export const RankingTops = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0;
`;

export const RankingUnit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  .coin {
    width: 48px;
    height: 48px;
  }
`;

export const NftBlock = styled.a`
  max-width: 600px;
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  border-radius: 16px;
  padding: 16px;
  margin: 0 auto;

  & > *:last-child {
    margin-left: auto;
  }

  .plane {
    margin-right: 8px;
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;

export const Banner = styled.a`
  display: flex;
  border-radius: var(--rounding-radius-xxl, 32px);
  background: var(--fill-primary, #faf8f7);
  box-shadow: 0px 8px 24px 0px rgba(51, 20, 0, 0.08),
    0px 4px 8px 0px rgba(51, 20, 0, 0.04);
  padding: 16px;
  isolation: isolate;
  position: relative;
  overflow: hidden;

  flex-direction: column;

  p.headerS {
    color: #000;
  }
  p.body.secondary {
    color: var(--text-invert-secondary, rgba(66, 61, 60, 0.64));
  }

  .decor {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 128px;
    height: 128px;
    object-position: right bottom;
    z-index: -1;
    &--desktop {
      display: none;
    }
  }
  button.btn {
    background: #ffaf1d;
    &:hover {
      background: #ffaf1d;
    }
    .action {
      color: var(--text-primary-on-brand, #000);
    }
  }

  .secondary {
    padding-right: 60px;
  }

  .desktop-btn {
    display: none;
  }

  .mobile-btn {
    margin-top: 16px;
    width: fit-content;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px var(--spacing-space-24, 24px) 24px
      var(--spacing-space-32, 32px);
    .desktop-btn {
      display: flex;
    }
    .mobile-btn {
      display: none;
    }

    .btn {
      border-radius: var(--rounding-radius-m, 16px);
      padding: 0 var(--spacing-space-48, 48px);
      height: auto;
      margin-top: 0;
    }

    .decor {
      &--desktop {
        display: block;
        right: -52px;
        width: 520px;
        height: 100%;
      }
      &--mobile {
        display: none;
      }
    }
  }
`;
